import Loading from 'components/Loading';
import Page404 from 'pages/Error';
import HomePage from 'pages/Home';
import OK9Page from 'pages/OK9';
import PrizeStructure from 'pages/OK9/prizeStructure';
import RuleFixPage from 'pages/OK9/rule_fix';
import { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import favicon from './assets/images/favicon.png';
import { SITE } from './config/config';

const favicons = {
  ok9: favicon
};

function Apps() {
  useEffect(() => {
    const faviconElement =
      document.querySelector("link[rel*='icon']") || document.createElement('link');
    faviconElement.type = 'image/png';
    faviconElement.rel = 'icon';
    faviconElement.href = favicons[SITE];
  }, []);

  return (
    <RecoilRoot>
      <BrowserRouter>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route exact path="/" element={<OK9Page />} />
            {/* <Route exact path="/prediction" element={<OK9Page />} /> */}
            {/* <Route path="/verify-account" element={<VerifyAccount />} /> */}
            <Route path="/sport" element={<OK9Page />} />
            <Route path="/rule" element={<RuleFixPage />} />
            <Route path="/prize-structure" element={<PrizeStructure />} />
            {/* <Route path="/lottery" element={<LotteryPrediction />} />
            <Route path="/lottery-rule" element={<LotteryRule />} />
            <Route path="/lottery-ketqua" element={<LotteryResultList />} />
            <Route path="/lottery-history" element={<LotteryHistoryList />} /> */}
            {/* Add other routes here */}
            <Route path="*" element={<Page404 />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </RecoilRoot>
  );
}

export default Apps;
